import React, {useEffect, useRef, useState} from 'react'
import {connect} from 'react-redux'
import {getMaterials, postMaterial, getTemplateExcelMaterial, uploadFileMaterial} from 'actions/procedureDefActions';
import {getCurrentUser} from 'actions/userActions';

import CreatableSelect from 'react-select/creatable';
import SendFile from 'components/common/sendFile'
import Spinner from 'components/common/Spinner';
// reactstrap components
import {
    Row, Col,
    Button,
    Input, Form, FormGroup,
    Modal
} from "reactstrap";
import ReactDatetime from "react-datetime";
import {
    clearErrorPostMaterial, deleteMaterial,
    deletePersonel, editMaterial, postMaterialType
} from "../../../actions/procedureDefActions";
import {getMaterialArchive, editMaterialArchive} from 'actions/ProcedurePricingActions'
import EditButton from "../../../components/medicalProceduresComponents/EditButton";
import DeleteButton from "../../../components/medicalProceduresComponents/DeleteButton";
import ArchiveButton from "../../../components/medicalProceduresComponents/ArchiveButton";
import MaterialArchiveTable from 'components/medicalProceduresComponents/MaterialArchiveTable'
import moment from 'moment';

const Material = (props) => {
    const valueConvert = (val) => {
        let nr = Number(val).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".", ",")
        return nr === "NaN" ? " X " : nr
    }
    const displayDate = (date) => {
        return date==='1900-01-01'?'':date
    }
    const {
        materials, editMaterial, deleteMaterial, postMaterial, errorPostMaterial, clearErrorPostMaterial, 
        unitTypes, postUnitType, typeLoading,
        materialTypes, postMaterialType, 
        newMaterial, newUnit, 
        getTemplateExcelMaterial, uploadFileMaterial, errorFileMaterial, loadingFileMaterial, getMaterials,
        getMaterialArchive, material_archive, editMaterialArchive, archive_loading,
        getCurrentUser, currentUser
    } = props
    const [formValues, setFormValues] = React.useState({
        company_index: "",
        name: "",
        'm_type': "",
        'unit_type': "",
        unit_price: null,
        ile_szt:null,
        'date_mat':''
    })
    const [formValuesEdit, setFormValuesEdit] = React.useState({
        company_index_edit: "",
        name_edit: "",
        'm_type_edit': "",
        'unit_type_edit': "",
        unit_price_edit: null,
        ile_szt_edit:null,
        'date_mat':''
    })
    const [idtoEdit, setIdEdit] = React.useState(null)
    const selectType = useRef(null)
    const selectMaterial = useRef(null)
    const seIdelement = (elem) => {
        let temp = {
            company_index_edit: elem.company_index,
            name_edit: elem.name,
            'm_type_edit': elem.m_type,
            'unit_type_edit': elem.unit_type,
            unit_price_edit: elem.unit_price,
            ile_szt_edit : elem.ile_szt,
            date_mat_edit: elem.date_mat=='1900-01-01'?'':elem.date_mat
        }
        setIdEdit(elem.id, setFormValuesEdit(temp))
    }
    const [archiveModal, setArchiveModal] = useState(false)
    const toggleArchiveModal = () => {
        setArchiveModal(!archiveModal)
    }
    const showArchive = (id) => {
        getMaterialArchive(id)
        setArchiveModal(true)
    }
    const handleFieldChange = (e) => {
        const fieldValue = e.target.value;
        const fieldIndex = e.target.id

        setFormValues((prevState) => {
            const prevLoginValues = {...prevState};
            prevLoginValues[fieldIndex] = fieldValue;
            return prevLoginValues;
        });
    }
    const [modalMini, setModalMini] = React.useState(false);
    const toggleModalMini = () => {
        setModalMini(!modalMini);
    };
    const [alertText, setAlertText] = React.useState("")
    const handleSubmit = (e) => {
        e.preventDefault();
        if (formValues['company_index'] === '' || formValues['name'] === '' || formValues['m_type'] === '' || formValues['unit_type'] === '' || !formValues['unit_price'] || formValues['date_mat'] === '' || formValues['date_mat'] === "Invalid date") {
            setAlertText("Wszystkie pola muszą być uzupełnione!", toggleModalMini());
            return 0
        }
        postMaterial(formValues)
        selectType.current.select.select.clearValue()
        selectMaterial.current.select.select.clearValue()
        setFormValues({company_index: "", name: "", 'm_type': "", 'unit_type': "", unit_price: 0, date_mat: ''})

    }
    const [isOpakowanie, setIsOpakowanie] = React.useState(false)
    React.useEffect(()=>{
        getCurrentUser()
    },[])

    React.useEffect(()=>{
        let name = displayUnit.filter(el => {return el.value == formValues['unit_type']})
        if(name.length!==0) {if(name[0]['label'] === 'opakowanie' || name[0]['label'] === "Opakowanie"){
            setIsOpakowanie(true)
        } else {setIsOpakowanie(false)
            setFormValues((prevState) => {
                const prevLoginValues = {...prevState};
                prevLoginValues["ile_szt"] = null;
                return prevLoginValues;
            })}}
             else {setIsOpakowanie(false)}
    }
    ,[formValues['unit_type']])
    //Unit type and material type
    const handleCreateMaterial = (newUnit) => {
        postMaterialType({"name": newUnit})

    }
    //jesli dodało
    React.useEffect(()=>{
        if(newMaterial !== null){
            setFormValues((prevState) => {
                const prevLoginValues = {...prevState};
                prevLoginValues["m_type"] = newMaterial.id;
                return prevLoginValues;
            });}
    },[newMaterial])
    React.useEffect(()=>{
        if(newUnit !== null){
            setFormValues((prevState) => {
                const prevLoginValues = {...prevState};
                prevLoginValues["unit_type"] = newUnit.id;
                return prevLoginValues;
            });}
    },[newUnit])
    const handleCreateUnit = (newUnit) => {
        postUnitType({"name": newUnit})
    }
    const [displayType, setDisplayType] = useState([]);
    const [displayUnit, setDisplayUnit] = useState([]);
    const preparUnit = () => {
        if (unitTypes && unitTypes.length > 0) {
            setDisplayUnit(unitTypes.map(material => {
                return {"label": material.name, "value": material.id}
            }))

        }
    }
    const prepareType = () => {
        if (materialTypes && materialTypes.length > 0) {
            setDisplayType(materialTypes.map(material => {
                return {"label": material.name, "value": material.id}
            }))


        }
    }


    useEffect(() => {
        preparUnit()

    }, [unitTypes])
    useEffect(() => {
        prepareType()

    }, [materialTypes])
    useEffect(() => {
        if (errorPostMaterial) {
            setAlertText("Błąd przy przetwarzaniu formularza!")
            toggleModalMini()}
    }, [errorPostMaterial])

    

    const usePrevious = (value) => {
        const ref = useRef();
        useEffect(() => {
          ref.current = value;
        });
        return ref.current;
      }
    const prevCount = usePrevious(loadingFileMaterial)
      useEffect(()=>{
        if(loadingFileMaterial){setShowModal(true)}
        if(prevCount||!archive_loading) getMaterials()   
    },
    [loadingFileMaterial, archive_loading])


    const submitEdit = (values, id) => {
        // console.log(formValuesEdit)

        const ValuesToSend = Object.assign({},values)
        Object.keys(ValuesToSend).map(key => delete Object.assign(ValuesToSend, {[key.replace("_edit", "")]: values[key]})[key])
        // console.log(formValuesEdit)
        if (ValuesToSend['company_index'] === '' || ValuesToSend['name'] === '' || ValuesToSend['m_type'] === '' || ValuesToSend['unit_type'] === '' || !ValuesToSend['unit_price'] || ValuesToSend['date_mat'] === '' || ValuesToSend['date_mat'] === "Invalid date") {
            setAlertText("Wszystkie pola muszą być uzupełnione!", toggleModalMini());
            // setIdEdit(null)
            return 0
        }
        editMaterial(ValuesToSend, id)
        setIdEdit(null)
    }
    const editArchive = (values, id) => {
        const ValuesToSend = values
        Object.keys(ValuesToSend).map(key => delete Object.assign(ValuesToSend, {[key.replace("_edit", "")]: values[key]})[key])
        if (ValuesToSend['company_index'] === '' || ValuesToSend['name'] === '' || ValuesToSend['m_type'] === '' || ValuesToSend['unit_type'] === '' || !ValuesToSend['unit_price'] || ValuesToSend['date_mat'] === '' || ValuesToSend['date_mat'] === "Invalid date") {
            setAlertText("Wszystkie pola muszą być uzupełnione!", toggleModalMini());
            return 0
        }
        editMaterialArchive(ValuesToSend, id)

        // setIdEdit(null)
    }
    //takes event and change formValuesEdit basend on it
    const changeValueInEditForm = (e) => {
        setFormValuesEdit((prevState) => {
            const prevLoginValues = {...prevState};
            prevLoginValues[e.target.id] = e.target.value;
            return prevLoginValues;
        });

    }
    const getTempalte = () => {
        getTemplateExcelMaterial()
    }
    const handleSubmitFile = (file) => {
        if(!file.file){console.log('brak pliku'); return 0}
        const formData = new FormData();
        formData.append(
            `file`,
            file.file );
        formData.append(
            `name`,
            file.name);
            uploadFileMaterial(formData)
    }
    const [ShowModal, setShowModal] = useState(false)
    const toggleModalMiniFile = () => {
        setShowModal(!ShowModal);
    };
    const checkIfExist = (e) =>{//działak jak nie ma paginacji !
        // console.log(e.target.value)
        if(materials.length>0){const elem = materials.find(el=> el.company_index===e.target.value)
        if(elem){
        setFormValues((prevState) => {
            const prevLoginValues = {...prevState};
            prevLoginValues["name"] = elem.name;
            prevLoginValues["unit_type"] = elem.unit_type;
            prevLoginValues["m_type"] = elem.m_type;
            return prevLoginValues;
        })}
        else{
            setFormValues((prevState) => {
                const prevLoginValues = {...prevState};
                prevLoginValues["name"] ="";
                prevLoginValues["unit_type"] = "";
                prevLoginValues["m_type"] = "";
                return prevLoginValues;
            }) 
        }
    }
    }

    return (
        <div className="content">
            <div>
                <SendFile getTemplate={getTempalte} handleSubmitFile={handleSubmitFile} currentUser={currentUser}></SendFile><br/><br/>
                {formValues && <Form className="settings-form" onSubmit={(e) => handleSubmit(e)} className='okraglaczki'>
                    <Row>
                        <Col md="1" sm="14">

                            <FormGroup>
                                <label htmlFor='company_index'>{`${"Indeks"}`}</label>
                                <Input
                                    className="border-input"
                                    placeholder={`${"id"}`}
                                    type="text"
                                    id="company_index"

                                    value={formValues['company_index']}
                                    onChange={(e) =>{checkIfExist(e); handleFieldChange(e)}}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3" sm="12">
                            <FormGroup>
                                <label htmlFor='name'>{`${"Materiał/lek/środek spożywczy..."}`}</label>
                                <Input
                                    className="border-input"
                                    placeholder={`${"Materiał"}`}
                                    type="text"
                                    id="name"
                                    value={formValues['name']}
                                    onChange={(e) => handleFieldChange(e)}

                                />
                            </FormGroup>
                        </Col>
                        <Col md="2" sm="12">
                            <FormGroup>
                                <label htmlFor='m_type'>{`${"Typ"}`}</label>
                                <CreatableSelect className="bigRadius select-wycena"
                                    id="m_type"
                                    ref={selectMaterial}
                                    isDisabled={typeLoading}
                                    isLoading={typeLoading}
                                    placeholder={"Wybierz..."}
                                    formatCreateLabel={function formatCreateLabel(inputValue) {
                                        return "Dodaj \"".concat(inputValue, "\"");
                                    }}
                                    aria-label={'Typ'}
                                    onChange={e => {
                                        if (e !== null) {
                                            setFormValues((prevState) => {
                                                const prevLoginValues = {...prevState};
                                                prevLoginValues["m_type"] = e.value;
                                                return prevLoginValues;
                                            });
                                        }
                                    }}
                                    noOptionsMessage={({inputValue}) => !inputValue ? "Zacznij pisać aby dodać nową jednostkę" : "Brak wyników"}
                                    onCreateOption={e => handleCreateMaterial(e)}
                                    options={displayType}
                                    value={displayType.find(item => item.value === formValues['m_type'])}
                                />

                            </FormGroup>
                        </Col>
                        <Col md="2" sm="12">
                            <FormGroup>
                                <label htmlFor='react-select-5-input'>{`${"Jednostka miary"}`}</label>
                                <CreatableSelect className="bigRadius select-wycena"
                                    id="unit_type"
                                    ref={selectType}
                                    isDisabled={typeLoading}
                                    isLoading={typeLoading}
                                    placeholder={"Wybierz..."}
                                    formatCreateLabel={function formatCreateLabel(inputValue) {
                                        return "Dodaj \"".concat(inputValue, "\"");
                                    }}
                                    label={'Jednostka miary'}
                                    aria-label={'Jednostka miary'}
                                    onChange={e => {
                                        setFormValues((prevState) => {
                                            if (e !== null) {
                                                // setDisplayUnit(e.label)
                                                const prevLoginValues = {...prevState};
                                                prevLoginValues["unit_type"] = e.value;
                                                return prevLoginValues;
                                            }
                                        });


                                    }}
                                    noOptionsMessage={({inputValue}) => !inputValue ? "Zacznij pisać aby dodwać nową jednostkę" : "Brak wyników"}
                                    onCreateOption={e => handleCreateUnit(e)}
                                    options={displayUnit}
                                    value={displayUnit.find(item => item.value === formValues['unit_type'])}
                                />
                            </FormGroup>
                        </Col>
                        {isOpakowanie ? <>
                            <Col md="1" sm="12">
                            <FormGroup>
                                <label htmlFor='ile_szt'>{`${"Ile szt."}`}</label>
                                <Input
                                    className="border-input"
                                    placeholder={`${""}`}
                                    type="text"
                                    id="ile_szt"

                                    value={formValues['ile_szt']}
                                    onChange={(e) => handleFieldChange(e)}
                                />
                            </FormGroup>
                            </Col>
                        </>:<></>}
                        <Col md="1" sm="12" >
                            <FormGroup>
                                <label htmlFor="unit_price">{`${"Cena[zł]"}`}</label>
                                <Input
                                    className="border-input"
                                    placeholder={`${"cena"}`}
                                    type="number"
                                    min='0'
                                    id="unit_price"
                                    step='0.01'
                                    value={formValues['unit_price']}
                                    onChange={(e) => handleFieldChange(e)}

                                />
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <Row className='m-0'>
                            <Col md="8" sm="12" className='p-0'>
                            <FormGroup>
                                <label htmlFor='date_mat'>{`${"Data"}`}</label>
                                <ReactDatetime
                                        inputProps={{
                                            className: "form-control",
                                            placeholder: "data obowiązywania",
                                            'aria-label': "data obowiązywania"
                                        }}
                                        dateFormat={"YYYY-MM-DD"}
                                        timeFormat={false}
                                        locale="pl"
                                        id='date_mat'
                                        onChange={(e) => {
                                            handleFieldChange({'target': {value: moment(e).format('YYYY-MM-DD'), id: 'date_mat'}})
                                        }}
                                        value={formValues['date_mat']}
                                        className='dateSelectWycena'
                                    />
                            </FormGroup>
                        </Col>
                        <Col md="4" >
                            <FormGroup style={{textAlign:"center"}}>
                                <label htmlFor='add_material'>{`${"Dodaj"}`}</label><br/>
                                <Button
                                    id="add_material"
                                    style={{width:"60px"}}
                                    className="btn m-0 btn-round"
                                    color="wycena"
                                    type="submit"
                                    outline
                                    disabled={currentUser && currentUser.company === null}
                                    aria-label={'Dodaj materiał'}
                                   >
                                    {/* <i className="far fa-plus-square fa-2x mr-0" ></i> */}
                                    <i className='nc-icon nc-simple-add'></i>
                                </Button>
                            </FormGroup>
                        </Col></Row>
                    </Col>

                    </Row>
                </Form>}
            </div>
            <table className='table table-border tableWycena'>
                <thead className=''>
                <tr className=''>
                    <th className="headerColor">Indeks materiału</th>
                    <th className="headerColor">Materiał/lek/środek spożywczy specjalnego <br/>przeznaczenia
                        żywieniowego/wyrób medyczny
                    </th>
                    <th className="headerColor">Typ</th>
                    <th className="headerColor">Jednostka <br/> miary</th>
                    <th className="headerColor">Cena jednostki <br/> miary w zł</th>
                    <th className="headerColor">Data obowiązywania</th>
                    <th className="headerColor">Opcje</th>
                </tr>
                </thead>
                <tbody>
                {materials && materials.map((elem) => {
                    return <>
                        {idtoEdit !== elem.id ? <tr>
                            <td>{elem.company_index}</td>
                            <td>{elem.name}</td>
                            <td>{displayType.find(item => item.value === elem.m_type) ? displayType.find(item => item.value === elem.m_type).label : elem.m_type}</td>
                            <td>{displayUnit.find(item => item.value === elem.unit_type) ? displayUnit.find(item => item.value === elem.unit_type).label : elem.unit_type} 
                            {elem.unit_type_name === "opakowanie" || elem.unit_type_name ==="Opakowanie" ?<>-{ elem.ile_szt} szt.</>:<></>}</td>
                            <td className='rightAlignCell'>{valueConvert(elem.unit_price)}</td>
                            <td className='rightAlignCell'>{displayDate(elem.date_mat)}</td>
                            {idtoEdit !== elem.id ?<td style={{whiteSpace:'nowrap'}} className='text-center'>
                                <ArchiveButton idx={elem.id} elem={elem} showArchive={showArchive}/> 
                                <EditButton idx={elem.id} elem={elem} edit={seIdelement}/> 
                                <DeleteButton idx = {elem.id}
                                id={elem.id}
                                deleteFunc={deleteMaterial}
                                text={"zasób materiałowy?"}/></td>:
                                <td>
                                <span style={{marginRight: "5px", cursor: "pointer"}} onClick={() => {
                                setIdEdit(null)
                            }}>
                                Anuluj</span>&nbsp;&nbsp;<span style={{marginLeft: "5px"}}>OK</span></td>}
                        </tr> : <tr>
                            <td>
                                <Input
                                    className="border-input"
                                    type="text"
                                    id="company_index_edit"
                                    value={formValuesEdit['company_index_edit']}
                                    onChange={e => changeValueInEditForm(e)}

                                />
                            </td>
                            <td>
                                <Input
                                    className="border-input"
                                    type="text"
                                    id="name_edit"
                                    value={formValuesEdit['name_edit']}
                                    onChange={e => changeValueInEditForm(e)}


                                /></td>
                            <td><CreatableSelect
                                className='select-wycena'
                                isDisabled={typeLoading}
                                isLoading={typeLoading}
                                placeholder={"Wybierz..."}
                                formatCreateLabel={function formatCreateLabel(inputValue) {
                                    return "Dodaj \"".concat(inputValue, "\"");
                                }}
                                onChange={e => {
                                    setFormValuesEdit((prevState) => {
                                        const prevLoginValues = {...prevState};
                                        prevLoginValues["m_type_edit"] = e.value;
                                        return prevLoginValues;
                                    });

                                }}
                                noOptionsMessage={({inputValue}) => !inputValue ? "Zacznij pisać aby dodwać nową jednostkę" : "Brak wyników"}
                                onCreateOption={e => handleCreateMaterial(e)}
                                options={displayType}
                                value={displayType.find(item => item.value === formValuesEdit['m_type_edit'])}
                            /></td>
                            <td>
                                <CreatableSelect
                                className='select-wycena'
                                isDisabled={typeLoading}
                                isLoading={typeLoading}
                                placeholder={"Wybierz..."}
                                formatCreateLabel={function formatCreateLabel(inputValue) {
                                    return "Dodaj \"".concat(inputValue, "\"");
                                }}
                                onChange={e => {
                                    setFormValuesEdit((prevState) => {
                                        const prevLoginValues = {...prevState};
                                        prevLoginValues["unit_type_edit"] = e.value;
                                        return prevLoginValues;
                                    });

                                }}
                                noOptionsMessage={({inputValue}) => !inputValue ? "Zacznij pisać aby dodwać nową jednostkę" : "Brak wyników"}
                                onCreateOption={e => handleCreateUnit(e)}
                                options={displayUnit}
                                value={displayUnit.find(item => item.value === formValuesEdit['unit_type_edit']) ? displayUnit.find(item => item.value === formValuesEdit['unit_type_edit']):""}
                            />
                                {displayUnit.find(item => item.value === formValuesEdit['unit_type_edit']).label === "opakowanie" || displayUnit.find(item => item.value === formValuesEdit['unit_type_edit']).label === "Opakowanie" ?
                                <div style={{margin:"5px"}}>Ile szt.:   
                                    <Input
                                    style={{width:"60%",height:"80%", display:"inline"}}
                                    className="border-input"
                                    placeholder={`${""}`}
                                    type="text"
                                    id="ile_szt_edit"
                                    value={formValuesEdit['ile_szt_edit']}
                                    onChange={(e) => changeValueInEditForm(e)}
                                /></div>:<></>}
                            
                            </td>
                            <td className='rightAlignCell'><Input
                                className="border-input"
                                type="number"
                                id="unit_price_edit"
                                value={formValuesEdit['unit_price_edit']}
                                onChange={e => changeValueInEditForm(e)}

                            /></td>
                            <td> <ReactDatetime
                                inputProps={{
                                    className: "form-control",
                                    placeholder: "data obowiązywania",
                                }}
                                dateFormat={"YYYY-MM-DD"}
                                timeFormat={false}
                                locale="pl"
                                id='date_mat_edit'
                                onChange={(e) => {
                                    changeValueInEditForm({'target': {value: moment(e).format('YYYY-MM-DD'), id: 'date_mat_edit'}})
                                }}
                                value={formValuesEdit['date_mat_edit']}
                                className='dateSelectWycena'
                            /></td>
                            <td style={{whiteSpace:'nowrap'}} className='text-center'>
                                 <Button
                                    className="btn-link "
                                    color="danger"
                                    data-toggle="tooltip"
                                    size="sm"
                                    type="button"
                                    onClick={() => {
                                    setIdEdit(null)
                                }}
                                >
                                    <i className="fas fa-times"></i>
                                </Button>

                                   <Button
                                    className="btn-link "
                                    color="success"
                                    data-toggle="tooltip"
                                    size="sm"
                                    type="button"
                                    onClick={(e) => {
                                    submitEdit(formValuesEdit, idtoEdit)
                                }}
                                >
                                    <i className="fas fa-check"></i>
                                </Button>

                            </td>
                        </tr>}

                    </>
                })}
                </tbody>
            </table>

            <Modal
                className="modal-sm"
                modalClassName="modal-primary"
                isOpen={modalMini}
                toggle={toggleModalMini}
            >
                <div className="modal-header justify-content-center">
                    <div className="modal-profile ml-auto mr-auto">
                        <i className="nc-icon nc-bulb-63"/>
                    </div>
                </div>
                <div className="modal-body">
                    <p>{alertText}</p>
                </div>
                <div className="modal-footer">
                    <Button
                        className='btn-link'
                        color="wycena"
                        data-dismiss="modal"
                        type="button"
                        onClick={e => {
                            toggleModalMini();
                            clearErrorPostMaterial()
                        }}
                    >
                        Zamknij
                    </Button>
                </div>
            </Modal>
            <Modal
             className="modal-sm"
             modalClassName="modal-primary"
             isOpen={ShowModal}
             toggle={toggleModalMiniFile}
             >
                 <div className="modal-header justify-content-center">
                    <div className="modal-profile ml-auto mr-auto">
                        <i className="nc-icon nc-bulb-63"/>
                    </div>
                </div>
                <div className="modal-body">
                    <p style={{textAlign:"center"}}>{loadingFileMaterial? <><Spinner/></>:<>
                    {errorFileMaterial ?<>Wystąpił błąd, sprawdź wprowadzane dane i spróbuj ponownie.</>:<>Pomyślnie zaimportowano dane!</>}
                    </>}</p>
                </div>
                <div className="modal-footer">
                    <Button
                        className='btn-link'
                        color="wycena"
                        data-dismiss="modal"
                        type="button"
                        onClick={e => {
                            toggleModalMiniFile();
                        }}>
                        Zamknij
                    </Button>
                </div>
            </Modal>
            <Modal
                size='xl'
                modalClassName="modal-primary"
                isOpen={archiveModal}
                toggle={toggleArchiveModal}
                >
                 <div className="modal-header justify-content-center">
                    <div className="modal-profile ml-auto mr-auto">
                        <i className="far fa-file-archive"/> 
                    </div>
                </div>
                <div className="modal-body">
                    <MaterialArchiveTable materials={material_archive} submitEdit={editArchive}
                    displayType={displayType} displayUnit={displayUnit} typeLoading={typeLoading} 
                    handleCreateUnit={handleCreateUnit} handleCreateMaterial={handleCreateMaterial}
                    />
                </div>
                <div className="modal-footer">
                    <Button
                        className='btn-link'
                        color="wycena"
                        style={{width: '100%'}}
                        data-dismiss="modal"
                        type="button"
                        onClick={e => {
                            toggleArchiveModal()
                        }}>
                        Zamknij
                    </Button>
                </div>
            </Modal>

        </div>
    )
}
const mapStateToProps = state => ({
    errorPostMaterial: state.procedureDefReducer.errorPostMaterial,
    errorFileMaterial: state.procedureDefReducer.errorFileMaterial,
    loadingFileMaterial: state.procedureDefReducer.loadingFileMaterial,
    material_archive: state.ProcedurePricingReducer.material_archive,
    archive_loading: state.ProcedurePricingReducer.archive_loading,
    currentUser: state.UserReducer.currentUser
    // typeLoading: state.procedureDefReducer.typeLoading
})
export default connect(mapStateToProps, {getCurrentUser, postMaterial, deleteMaterial, clearErrorPostMaterial, editMaterial, getTemplateExcelMaterial, uploadFileMaterial, getMaterials, getMaterialArchive, editMaterialArchive})(Material)
